
import { computed, defineComponent } from "vue";

export default defineComponent({
	props: {
		mainColumnWidth: {
			type: Number,
			required: false,
			default: 9
		},
		centered: {
			type: Boolean,
			required: false,
			default: true
		},
	},
	setup(props) {
		const columnWidthMain = computed(() => {
			return `col-md--${props.mainColumnWidth}`;
		});

		return { columnWidthMain };
	},
});
